import { Tooltip } from "../../../components/UI/Tooltip";

const RegistrationTypeSwitch = ({ choseType, handleTypeChange }) => (
  <div className="app-ai-quote-registration-switch">
    <button
      onClick={() => handleTypeChange("design")}
      className={choseType === "design" ? "active" : ""}
    >
      Upload Design Layouts
    </button>
    <button
      onClick={() => handleTypeChange("website")}
      className={choseType === "website" ? "active" : ""}
    >
      Existing Website
      <Tooltip data={"Ready Website or Website Example"} />
    </button>
  </div>
);

export default RegistrationTypeSwitch;
